import React, {useContext, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';
const IcpdfDetalleBoletinLabModal = () => {


    moment.locale('spanish');
    const FechaImpresion = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01
    
    const { DatodetalleBoletinModal, datoIC } = useContext(UserContext);
    

 
  
    const formatterPeso = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
    })
    
    const TblBoletinResumenpdf = (
        <>
            { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen != null ?
                <View style={{ width: '100%' }}>

                <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. de Infracciones</Text>
                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Deudas</Text>
                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Multas</Text>
                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>N. Instituciones</Text>
                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>Fecha Deuda más reciente</Text>
                        <Text style={{ width: '16%', height: '25px', padding: '1,10', textAlign: 'center' }}>Fecha Multa más reciente</Text>

                    </View>
                        <View style={{ flexDirection: 'row', fontSize: 8 }} key={uuid()}>
                            
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroInfracciones}</Text>
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroDeudas}</Text>
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroMultas}</Text>
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroInstituciones}</Text>
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.FechaDeudaMasReciente}</Text>
                            <Text style={{ width: '16%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.FechaMultaMasReciente}</Text>
                        </View>
           

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN  </Text>}
        </>
    );

    const TblDetalleDeudasBoletin =(
        <>
        { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroDeudas != 0 ?
            <View style={{ width: '100%' }}>

       


                <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                    <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'left' }}>Institucion</Text>
                    <Text style={{ width: '20%', height: '25px', textAlign: 'left' }}>Motivo</Text>
                    <Text style={{ width: '8%', height: '25px', textAlign: 'center' }}>N° Boletín</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Boletín</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>N° Página</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'left' }}>Tipo de Infracción</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Infracción</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'right' }}>M$ Monto</Text>

                </View>


                { DatodetalleBoletinModal && DatodetalleBoletinModal.Deudas?.map((dDeudaspdf, iddeudapdf)=>(

                    <View style={{ flexDirection: 'row', fontSize: 8 }} key={iddeudapdf}>
                        <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{iddeudapdf + 1}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dDeudaspdf.Institucion}</Text>
                        <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dDeudaspdf.Motivo}</Text>
                        <Text style={{ width: '8%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dDeudaspdf.NumeroBoletin}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dDeudaspdf.FechaBoletin}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dDeudaspdf.NumeroPagina}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dDeudaspdf.TipoInfraccion}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dDeudaspdf.FechaInfraccion}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>{dDeudaspdf.Monto}</Text>
                    </View>
                ))}

            </View>

            : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
    </>
    ); 

    const TblDetalleMultasBoletin =(
        <>
        {DatodetalleBoletinModal && DatodetalleBoletinModal.Multas?.NumeroMultas != 0 ?
            <View style={{ width: '100%' }}>

       


                <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                    <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'left' }}>Institucion</Text>
                    <Text style={{ width: '20%', height: '25px', textAlign: 'left' }}>Motivo</Text>
                    <Text style={{ width: '8%', height: '25px', textAlign: 'center' }}>N° Boletín</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Boletín</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>N° Página</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'left' }}>Tipo de Infracción</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Infracción</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'right' }}>M$ Monto</Text>

                </View>


                {DatodetalleBoletinModal && DatodetalleBoletinModal.Multas?.map((dmultaspdf, idmultasdf)=>(

                    <View style={{ flexDirection: 'row', fontSize: 8 }} key={idmultasdf}>
                        <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idmultasdf + 1}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dmultaspdf.Institucion}</Text>
                        <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dmultaspdf.Motivo}</Text>
                        <Text style={{ width: '8%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dmultaspdf.NumeroBoletin}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dmultaspdf.FechaBoletin}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dmultaspdf.NumeroPagina}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dmultaspdf.TipoInfraccion}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dmultaspdf.FechaInfraccion}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>{dmultaspdf.Monto}</Text>
                    </View>
                ))}

            </View>

            : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
    </>
    ); 

    const ReporteBoletindPdf =()=>(
         
        <Document >
            
            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
                  
                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {FechaImpresion} </Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
                   
                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.Nombre : datoIC.Identificacion?.Nombre} RUT {datoIC.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN BOLETIN LABORAL</Text>
                        {TblBoletinResumenpdf}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE BOLETIN LABORAL (DEUDAS)</Text>
                        {TblDetalleDeudasBoletin}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE BOLETIN LABORAL (MULTAS)</Text>
                        {TblDetalleMultasBoletin}
                    </View>

                    <View style={{ width: '50%', alignContent: 'left' }}>
                   {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoIC.ID} - {uuid(datoIC.ID)}</Text>
                    </View>


                </View>


            </Page>

        </Document>

    ); 



    
    
    return useMemo(
        ()=>(
        <div>

        
        <PDFDownloadLink  document={<ReporteBoletindPdf />} fileName={`${uuid()}.pdf`}>

        {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
          
        </PDFDownloadLink>
            
           

        </div>
    ),[]
    
);
}

export default IcpdfDetalleBoletinLabModal
